/**
 * Is this a plausible address on one of the allowed domains?
 *
 * Lives in its own module, free of DOM and Keycloak imports, so it can be
 * tested without a browser or build-time config. people-picker.ts pulls in
 * chrome.ts for escapeHtml, which transitively requires the Keycloak
 * environment — fine at runtime, needless for a string check.
 *
 * This is feedback only. The API enforces the same rule at upload, so a bug
 * here cannot grant access to anyone who could not otherwise sign in — it
 * would just let a doomed address into the box.
 */
export function isAllowedEmail(value: string, domains: string[]): boolean {
  const v = value.trim().toLowerCase();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return false;
  // Compare the domain exactly rather than by suffix: "nottwentyfirstgroup.com"
  // and "twentyfirstgroup.com.evil.io" both end with an allowed domain as a
  // substring, and neither should pass.
  const domain = v.split("@")[1] ?? "";
  return domains.map((d) => d.trim().toLowerCase()).includes(domain);
}
